import { render, staticRenderFns } from "./OpenEndedContent.vue?vue&type=template&id=5bc65960&scoped=true&"
import script from "./OpenEndedContent.vue?vue&type=script&lang=js&"
export * from "./OpenEndedContent.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedContent.vue?vue&type=style&index=0&id=5bc65960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc65960",
  null
  
)

export default component.exports